import {notificationConstants} from "../constants/notification.constants";

const initState = {
    getList: null,
    getUnReadList: null,
    errors: null
};

export function notificationReducer(state = initState, action) {
    switch (action.type) {
        case notificationConstants.GET_LIST_REQUEST:
            return {
                ...state,
                getList: null
            }
        case notificationConstants.GET_LIST_SUCCESS:
            return {
                ...state,
                getList: action.list
            }
        case notificationConstants.GET_LIST_ERROR:
            return {
                ...state,
                errors: action.error
            }
        case notificationConstants.GET_LIST_UNREAD_SUCCESS:
            return {
                ...state,
                getUnReadList: action.list,
                errors: null
            }
        case notificationConstants.GET_LIST_UNREAD_ERROR:
            return {
                ...state,
                getUnReadList: null,
                errors: action.error
            }
        default:
            return state
    }
}